import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { House, Question, CaretUp, CaretDown, UserCircle, SignOut, SignIn } from '@phosphor-icons/react';
import { DASHBOARD } from '@/constants/testIds';
import { useAuth } from '@/context/AuthContext';

const Navbar = ({ isCollapsed, onToggleCollapse }) => {
  const location = useLocation();
  const { user, isAuthenticated, openAuthModal, logout } = useAuth();
  const isActive = (path) => location.pathname === path;

  if (isCollapsed) {
    return (
      <div className="fixed top-2 left-1/2 -translate-x-1/2 z-50 transition-all duration-300">
        <button
          onClick={onToggleCollapse}
          className="px-3 py-1 bg-slate-900/95 hover:bg-slate-800 text-cyan-400 border border-cyan-500/40 rounded-full shadow-2xl backdrop-blur flex items-center gap-1.5 text-[11px] font-mono font-semibold hover:scale-105 transition-all"
          title="Mostrar Cabecera"
        >
          <span className="text-[#00E5FF] font-bold">AI BRIDGE HUB</span>
          <CaretDown size={14} className="text-cyan-400" />
        </button>
      </div>
    );
  }

  return (
    <nav className="h-12 bg-[#0E1117] border-b border-white/[0.08] flex items-center justify-between px-4 z-30 transition-all duration-300">
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full bg-cyan-400" />
          <h1 className="text-sm font-semibold tracking-tight text-white font-sans">
            AI BRIDGE HUB
          </h1>
        </div>
        <span className="text-xs text-slate-400 font-normal hidden sm:inline border-l border-white/[0.08] pl-3">Universal AI Interoperability</span>
      </div>

      <div className="flex items-center gap-3">
        <div className="flex items-center gap-1 bg-white/[0.03] p-0.5 rounded-lg border border-white/[0.06]">
          <Link
            to="/"
            data-testid={DASHBOARD.navDashboard}
            className={`px-3 py-1 text-xs font-sans font-medium flex items-center gap-1.5 rounded-md transition-all ${
              isActive('/')
                ? 'bg-white/[0.08] text-white shadow-sm'
                : 'text-slate-400 hover:text-slate-200 hover:bg-white/[0.04]'
            }`}
          >
            <House size={14} weight={isActive('/') ? 'fill' : 'regular'} />
            Dashboard
          </Link>
          <Link
            to="/how-to-use"
            data-testid={DASHBOARD.navHowToUse}
            className={`px-3 py-1 text-xs font-sans font-medium flex items-center gap-1.5 rounded-md transition-all ${
              isActive('/how-to-use')
                ? 'bg-white/[0.08] text-white shadow-sm'
                : 'text-slate-400 hover:text-slate-200 hover:bg-white/[0.04]'
            }`}
          >
            <Question size={14} weight={isActive('/how-to-use') ? 'fill' : 'regular'} />
            How to Use
          </Link>
        </div>

        {/* User / Authentication Badge & Action */}
        <div className="flex items-center gap-2 pl-2 border-l border-white/[0.08]">
          {isAuthenticated && user ? (
            <div className="flex items-center gap-2">
              <span className="flex items-center gap-1.5 text-xs text-slate-300 font-sans font-medium px-2.5 py-1 bg-white/[0.04] border border-white/[0.08] rounded-md">
                <UserCircle size={14} className="text-emerald-400" />
                <span className="max-w-[120px] truncate">{user.display_name || user.email}</span>
              </span>
              <button
                onClick={logout}
                className="flex items-center gap-1 px-2.5 py-1 text-xs text-rose-400 hover:bg-rose-500/10 border border-rose-500/20 rounded-md transition-all font-sans"
                title="Sign Out"
              >
                <SignOut size={14} />
                <span className="hidden sm:inline">Logout</span>
              </button>
            </div>
          ) : (
            <button
              onClick={openAuthModal}
              className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-sans font-medium text-slate-950 bg-cyan-400 hover:bg-cyan-300 rounded-md transition-all shadow-sm"
              title="Sign in to your account"
            >
              <SignIn size={14} />
              <span>Sign In</span>
            </button>
          )}
        </div>

        {onToggleCollapse && (
          <button
            onClick={onToggleCollapse}
            className="p-1.5 text-slate-400 hover:text-slate-200 hover:bg-white/[0.04] rounded-md transition-all"
            title="Ocultar Cabecera"
          >
            <CaretUp size={16} />
          </button>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
